<template>
  <v-row class="ma-0" align="center" justify="center">
    <v-col align="center" style="width: 490px;font-size: 13px">
      <div style="width: 740px;display:flex;justify-content: center;flex-flow: column;">
        <p class="mb-4" style="font-size: 14px;margin-left: 5px;text-align: left;">
          ※令和7年4月1日より、アカウント登録の仕方が変更になります。画面右下にある<br>
          &emsp;「アカウント登録」ボタンより、先生ご自身でアカウント登録をお願いします。
        </p>
        <p class="mb-4" style="font-size: 14px;margin-left: 5px;text-align: left;">
          令和8年度のパスワードの有効期限は、令和9年3月31日の23:59までです。御注意ください。<br>
        </p>
        <p class="mb-4" style="font-size: 14px;margin-left: 5px;text-align: left;">
          <span style="color: red;font-weight: bold;">※令和8年度用のアカウントは、令和8年4月1日の0:00よりご登録いただけます。<br>
          &emsp;令和7年度より引き続きご利用の方も、改めてアカウントの発行をお願いいたします。</span>
        </p>
      </div>

      <v-card class="signin-card pa-10 elevation-10">
        <div class="text-center">
          <img class="logo" src="@/assets/img/header_logo.png" alt="新学社">
        </div>
        <v-form ref="form" @submit.prevent>
          <v-card-text class="mt-12 text-center">
            <v-text-field
              label="Login ID"
              name="login"
              prepend-icon="mdi-account"
              type="text"
              v-model="login"
              :disabled="!isRecommendedEnvironment"
            ></v-text-field>

            <v-text-field
              id="password"
              label="Password"
              name="password"
              prepend-icon="mdi-lock"
              :type="showPassword ? 'text' : 'password'"
              v-model="password"
              :disabled="!isRecommendedEnvironment"
              :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
              @click:append="showPassword = !showPassword"
            ></v-text-field>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
          <!-- 推奨環境のみログイン可能 -->
          <template v-if="isRecommendedEnvironment">
            <v-btn
              rounded
              block
              color="secondary"
              class="signin-btn"
              @click="signIn"
              type="submit"
              :disabled="!activateSubmit"
            >
              Sign In
            </v-btn>
          </template>
          <template v-else>
            <p class="not-recommended__message">ご利用いただいているブラウザでは正しく動作しないため、WindowsはEdgeまたはChrome、MacはSafariをご利用ください</p>
          </template>
          </v-card-actions>
        </v-form>
      </v-card>

      <!-- 動作環境ページ --><br>
      ブラウザは、WindowsはEdgeまたはChrome、MacはSafariをご利用ください。<br>
      詳しい動作環境は
      <router-link
        class="mt-8 env-check__link"
        to="/env_check"
        target="_blank"
      >
        こちら
      </router-link>
      をご覧ください。
    </v-col>

    <v-col align="center" style="width: 490px;font-size: 13px">
      <v-manual-card
        style='width: 144px;'
        detail="よくある質問"
        @click="openUrl('/faq.pdf')"
      >
        <template v-slot:heading>
          <v-img
            class="avatar-manual"
            src="@/assets/img/f_f_business_42_s512_f_business_42_0nbg.png"
          />
        </template>
      </v-manual-card>

      <v-card class="mt-5 riyou-message">
        ＜ご利用に際しての注意事項＞<br>
        ご提供するコンテンツの著作権は新学社にございます。<br>
        各コンテンツはご採用年度のご採用学年でのみご利用可能です。<br>
        ダウンロード後のデータも含め、上記以外でのご利用は、 <span style="font-weight: bold;">著作権法に抵触する恐れがございますので、</span> お控えください。
      </v-card>
      <v-btn x-large color="secondary" @click="$router.push('/enrollment/auth')">上記に同意してアカウント登録</v-btn>
      <div class="message--red mt-3" style="width: 580px;display:flex;justify-content: center;flex-flow: column;">
        <p class="mb-4" style="font-size: 14px;margin-left: 5px;text-align: left;">
          ※有料用紙印刷を希望される場合は、上記アカウント登録ボタンではなく、<br>
          &emsp;下記アカウント登録表に必要事項をご記入いただき、特約店にお渡しください。
        </p>
        <a class="mb-4 link" style="font-size: 15px;margin-left: 5px;text-align: center;" href="/有料アカウント登録票（R7）.xlsx">
          有料用紙印刷 アカウント登録票
        </a>
      </div>
      <v-inquiry-button class="mt-5" font-size="14px" />

      <!-- SSO動作確認ボタン（開発環境のみ） -->
      <!-- <v-btn
        v-if="isDevelopment"
        class="mt-5"
        color="warning"
        @click="ssoTestDialog = true"
      >
        SSO動作確認
      </v-btn> -->
    </v-col>

    <!-- SSO動作確認ダイアログ -->
    <v-dialog
      v-model="ssoTestDialog"
      max-width="500px"
    >
      <v-card>
        <v-toolbar class="title">SSO動作確認</v-toolbar>
        <v-card-text class="pt-5">
          <v-text-field
            v-model="ssoUid"
            label="UID"
            hint="SSOユーザーのUID"
            persistent-hint
          ></v-text-field>
          <v-text-field
            v-model="ssoSchoolCode"
            label="学校コード"
            hint="学校コード（ユーザー作成時に使用）"
            persistent-hint
            class="mt-3"
          ></v-text-field>
          <v-select
            v-model="ssoAccountType"
            :items="['free', 'paid']"
            label="アカウントタイプ"
            class="mt-3"
          ></v-select>
          <v-divider class="mt-4 mb-2"></v-divider>
          <p class="text-caption mb-2">ライセンス情報（SSO認証時に使用）</p>
          <v-row>
            <v-col cols="6">
              <v-select
                v-model="ssoGradeId"
                :items="[{text: '中学1年', value: 7}, {text: '中学2年', value: 8}, {text: '中学3年', value: 9}]"
                item-text="text"
                item-value="value"
                label="学年"
              ></v-select>
            </v-col>
            <v-col cols="6">
              <v-select
                v-model="ssoSubjectId"
                :items="[
                  {text: '国語', value: 9},
                  {text: '数学', value: 20},
                  {text: '英語', value: 26},
                  {text: '理科', value: 24},
                  {text: '社会', value: 13},
                  {text: '技術', value: 34},
                  {text: '家庭', value: 35},
                  {text: '保健・体育', value: 30},
                ]"
                item-text="text"
                item-value="value"
                label="LMS教科ID"
              ></v-select>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="justify-space-around pb-4">
          <v-btn color="primary" @click="ssoCreateUser" :loading="ssoLoading">
            1. ユーザー作成
          </v-btn>
          <v-btn color="success" @click="ssoAuth" :loading="ssoLoading">
            2. SSO認証
          </v-btn>
          <v-btn color="error" @click="ssoDeleteUser" :loading="ssoLoading">
            3. ユーザー削除
          </v-btn>
        </v-card-actions>
        <v-card-actions class="justify-center pb-4">
          <v-btn text @click="ssoTestDialog = false">閉じる</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- 社会・技術・家庭に関しては学年が合っているかを確認 -->
    <!-- https://combine.backlog.jp/view/SIN_DEV-303 -->
    <v-dialog
      v-model="isRequiredCheckGrade"
      persistent
      max-width="400px"
    >
      <v-card
        min-height="150px"
      >
        <v-toolbar
          class="title"
        >ログインするアカウントの学年確認</v-toolbar>

        <v-card-text class="px-5">
          <!-- 学年確認 -->
          <div class="py-3">
            <p class="mb-0">{{grade}}年のテスト作成で間違いないでしょうか。</p>
          </div>
        </v-card-text>

        <v-card-actions class="card-action">
          <template>
            <v-btn color="secondary" dark class="dialog-Button" @click="checkGrade(true)">はい</v-btn>
            <v-btn color="gray" class="dialog-Button" @click=checkGrade(false)>いいえ</v-btn>
          </template>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import VManualCard from '@/components/molecules/ManualCard'
import VInquiryButton from '@/components/molecules/InquiryButton'

export default {
  components: {
    VManualCard,
    VInquiryButton,
  },
  computed: {
    // ログインボタンの活性非活性化
    activateSubmit() {
      return this.login !== '' && this.password !== ''
    },
    // 開発環境かどうか
    isDevelopment() {
      return process.env.NODE_ENV === 'development'
    },
    // 推奨環境かどうか
    isRecommendedEnvironment() {
      const userAgent = window.navigator.userAgent.toLowerCase();

      if(userAgent.indexOf('msie') != -1 || userAgent.indexOf('trident') != -1) {
        // IE
        return false
      } else if(userAgent.indexOf('edge') != -1) {
        return true
      } else if(userAgent.indexOf('chrome') != -1) {
        return true
      } else if(userAgent.indexOf('safari') != -1) {
        return true
      } else if(userAgent.indexOf('firefox') != -1) {
        return false
      } else if(userAgent.indexOf('opera') != -1) {
        return false
      } else {
        return false
      }
    }
  },
  data () {
    return {
      login: '',
      password: '',
      showPassword: false,
      grade: '',
      isRequiredCheckGrade: false,
      // SSO動作確認用
      ssoTestDialog: false,
      ssoUid: 'sso-test-user',
      ssoSchoolCode: '010101',
      ssoAccountType: 'free',
      ssoGradeId: 7,
      ssoSubjectId: 9,  // LMS教科ID: 9=国語
      ssoLoading: false,
      ssoToken: null,
    }
  },
  async mounted() {
    // ログイン中であればログアウト処理
    if (this.$store.state.user.accessToken) {
      await this.$axios.delete('/api/v1/auth/sign_out')
    }
    // ログイン中と判断される値を初期化
    this.$store.commit('user/logout', {})
  },
  methods: {
    // ログインAPI実行処理
    async signIn() {
      const res = await this.$axios.post('/api/v1/auth/sign_in', {
        login: this.login,
        password: this.password,
      })
      this.$app.$refs.loading.open({message: 'ログイン中です'})
      // 成功時の処理

      // レスポンスヘッダーから認証情報を取得
      const auth = {
        accessToken: res.headers['access-token'],
        client:      res.headers['client'],
        uid:         res.headers['uid'],
        userId:      res.data.data.id
      }
      // 認証情報とログイン情報をstoreに格納
      this.$store.commit('user/login', auth)
      this.$store.commit('user/setRole', { role: res.data.data.type })
      this.$store.commit('user/setLastOperatedDate', { lastOperatedDate: new Date })
      this.$store.commit('user/setUserId', { userId: res.data.data.id })
      this.$store.commit('user/setIsDemo', { isDemo: res.data.data.is_demo })
      this.$store.commit('user/setRemainingDownloadCount', { remainingDownloadCount: res.data.data.remaining_download_count })
      this.$store.commit('user/setAccountType', { accountType: res.data.data.account_type })
      // axiosのヘッダーにログイン情報設定
      const strageData = JSON.parse(sessionStorage.getItem('ShingakushaEpro'));
      this.$axios.defaults.headers.common['access-token'] = strageData.user.accessToken;
      this.$axios.defaults.headers.common['client']       = strageData.user.client;
      this.$axios.defaults.headers.common['uid']          = strageData.user.uid;
      // マスタデータ取得
      await this.$store.dispatch('master/getMasterData')
      // 先生アカウントの場合、所属学校データを取得（ナビバー表示用）
      if(this.$store.getters['user/isTeacher']) {
        const url = `api/v1/schools/${res.data.data.school_id}`
        const school = await this.$axios(url)
        this.$store.commit('user/setSchoolData', { schoolData: school.data })
        // 担当教科をリセット
        this.$store.commit('setSubjectTeachers', [])
        // 進学アカウント判定
        const subjectTeachersResponse = await this.$axios.get('/api/v1/teacher/subject_teachers')
        this.$store.commit('user/setIsShingaku', { isShingaku: subjectTeachersResponse.data.some(st => st.is_shingaku) })
      }

      // 社会・技術・家庭に関しては学年が合っているかを確認
      // https://combine.backlog.jp/view/SIN_DEV-303
      const regex = /(sh|gi|ka)([123])-.*$/;
      const match = this.login.match(regex);
      if (match) {
        this.grade = match[2]
        this.isRequiredCheckGrade = true
        this.$app.$refs.loading.close()
        return
      }

      // ログインアカウントによって遷移先を振り分ける（管理者・先生）
      this.$router.push(this.$store.getters['user/homePath'])
      this.$app.$refs.loading.close()
    },
    async checkGrade(result) {
      if (result) {
        this.$router.push(this.$store.getters['user/homePath'])
      } else {
        this.$toasted.global.error({ message: '該当学年のアカウントで再度ログインしてください。' })
        this.grade = ""
        this.isRequiredCheckGrade = false
        if (this.$store.state.user.accessToken) {
          await this.$axios.delete('/api/v1/auth/sign_out')
        }
        // ログイン中と判断される値を初期化
        this.$store.commit('user/logout', {})
      }
    },
    openUrl(url) {
      window.open(url, '_blank')
    },
    // SSO動作確認用メソッド
    async ssoGetToken() {
      const res = await this.$axios.post('/api/v1/sso/get_token', {
        payload: {
          clientId: 'STmiUkmhtxSF4KNoLUJRtWD6Tbbt5SjJ',
          clientSecret: '66a2e75ae58cc59a2b721ab029ca9f53acc41655319e42a69924f8d1ee72dd9aafb8b08c56a6a500cc6bb6d80f95cf7e2a4bc04b4a419843ba4e9759451ef44f',
        }
      })
      this.ssoToken = res.data.accessToken
      return this.ssoToken
    },
    async ssoCreateUser() {
      this.ssoLoading = true
      try {
        const token = await this.ssoGetToken()
        const res = await this.$axios.post('/api/v1/sso/users', {
          payload: {
            token: token,
            systemCode: 'lms',
            singCode: 'sing',
            verb: 'create_user',
            uid: this.ssoUid,
            schoolCode: this.ssoSchoolCode,
            accountType: this.ssoAccountType,
          }
        })
        this.$toasted.global.success({ message: `ユーザー作成成功: ID=${res.data.id}` })
      } catch (error) {
        const message = error.response?.data?.errors?.join(', ') || 'ユーザー作成に失敗しました'
        this.$toasted.global.error({ message })
      } finally {
        this.ssoLoading = false
      }
    },
    async ssoAuth() {
      this.ssoLoading = true
      try {
        const token = await this.ssoGetToken()
        // SSO認証リクエスト（リダイレクトが返る）
        const form = document.createElement('form')
        form.method = 'POST'
        form.action = `${process.env.VUE_APP_API_ENDPOINT}/api/v1/sso/auth`

        const payloadInput = document.createElement('input')
        payloadInput.type = 'hidden'
        payloadInput.name = 'payload[token]'
        payloadInput.value = token
        form.appendChild(payloadInput)

        const uidInput = document.createElement('input')
        uidInput.type = 'hidden'
        uidInput.name = 'payload[uid]'
        uidInput.value = this.ssoUid
        form.appendChild(uidInput)

        const systemCodeInput = document.createElement('input')
        systemCodeInput.type = 'hidden'
        systemCodeInput.name = 'payload[systemCode]'
        systemCodeInput.value = 'lms'
        form.appendChild(systemCodeInput)

        const singCodeInput = document.createElement('input')
        singCodeInput.type = 'hidden'
        singCodeInput.name = 'payload[singCode]'
        singCodeInput.value = 'sing'
        form.appendChild(singCodeInput)

        const verbInput = document.createElement('input')
        verbInput.type = 'hidden'
        verbInput.name = 'payload[verb]'
        verbInput.value = 'auth_user'
        form.appendChild(verbInput)

        // licenses配列を追加
        const gradeIdInput = document.createElement('input')
        gradeIdInput.type = 'hidden'
        gradeIdInput.name = 'payload[licenses][0][gradeId]'
        gradeIdInput.value = this.ssoGradeId
        form.appendChild(gradeIdInput)

        const subjectIdInput = document.createElement('input')
        subjectIdInput.type = 'hidden'
        subjectIdInput.name = 'payload[licenses][0][subjectId]'
        subjectIdInput.value = this.ssoSubjectId
        form.appendChild(subjectIdInput)

        document.body.appendChild(form)
        form.submit()
      } catch (error) {
        const message = error.response?.data?.errors?.join(', ') || 'SSO認証に失敗しました'
        this.$toasted.global.error({ message })
        this.ssoLoading = false
      }
    },
    async ssoDeleteUser() {
      this.ssoLoading = true
      try {
        const token = await this.ssoGetToken()
        await this.$axios.post('/api/v1/sso/users/delete', {
          payload: {
            token: token,
            systemCode: 'lms',
            singCode: 'sing',
            verb: 'delete_user',
            uid: this.ssoUid,
          }
        })
        this.$toasted.global.success({ message: 'ユーザー削除成功' })
      } catch (error) {
        const message = error.response?.data?.errors?.join(', ') || 'ユーザー削除に失敗しました'
        this.$toasted.global.error({ message })
      } finally {
        this.ssoLoading = false
      }
    },
  }
}
</script>

<style lang="stylus" scoped>
.row
  height 100%

.logo
  margin-right 18px

.signin
  &-card
    height 500px
    max-width 371px
    + tablet-horizontal()
        height 450px
        max-width 321px
    + tablet-vertical()
        height 450px
        max-width 301px

  &-btn
    color white !important
    margin-top 60px
  &-btn:enabled
    background-image linear-gradient(to bottom, #10318b, #55669b 30%, #2b3555)

.not-recommended__message
  color red

.attention-message
  color red
  font-size 14px

.attention_subject
  margin-right 110px

.message__area
  color: #f10;
  font-weight: bold;
  font-size: 16px;
  margin-bottom: 30px;
  text-decoration: underline;

.title
  justify-content center
  background-color: #2a5594 !important
  color white

.card-action
  justify-content space-around

.dialog-Button
  width 100px
  height 50px

.message--red
  color red

.link
  font-style italic
  text-decoration: underline #FF3028;
  font-weight bold
  color: red !important
  cursor pointer

.riyou-message
  margin-top 20px
  display block
  text-align left
  width 450px
  margin-bottom 35px
  background white
  padding 10px

.avatar-manual
  margin-top: 10px;
  max-width: 60px;
  background-color #a5a5a5
  box-shadow 1px 1px 1px 1px #d8d8d8
</style>
